import React, { Component } from 'react';
import legacyEventHub from '~/modules/legacyRuntime.js';

class SearchMenuLengthInputs extends Component {
  constructor(props) {
    super(props);

    this.handleChange = this.handleChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);

  }

  handleChange(e) {
    let minInputValue = parseInt(this.refs.minField?.value, 10),
        maxInputValue = parseInt(this.refs.maxField?.value, 10);

    if (typeof tempoLengthChangeTimeout !== 'undefined') {
        clearTimeout(tempoLengthChangeTimeout);
    }

    this.props.submitLengthChange(minInputValue, maxInputValue);

    window.tempoLengthChangeTimeout = setTimeout(function() {
        legacyEventHub.trigger('queryInputSubmit');
    }, 500);
  }

  handleKeyPress(e) {
      if (e.key === 'Enter'){
        legacyEventHub.trigger('queryInputSubmit');
      }
  }

  render() {
    let wrapperClassName = this.props.className ? 'search-menu__query-input-wrapper search-menu__query-input-wrapper--length ' + this.props.className : 'search-menu__query-input-wrapper search-menu__query-input-wrapper--length';

    return (
      <div className={wrapperClassName}>
        <div className='row'>
          <div className='col6 padding-right5'>
            <input type='text' className='search-menu__min-length-input' placeholder={this.props.locale === 'de' ? 'min. Länge (sec)' : 'Min length (sec)'} ref='minField' onChange={this.handleChange} onKeyPress={this.handleKeyPress} value={this.props.minLength}/>
            </div>
          <div className='col6 padding-left5'>
            <input type='text' className='search-menu__max-length-input' placeholder={this.props.locale === 'de' ? 'max. Länge (sec)' : 'Max length (sec)'} ref='maxField' onChange={this.handleChange} onKeyPress={this.handleKeyPress} value={this.props.maxLength}/>
          </div>
        </div>
      </div>
    )
  }
};

SearchMenuLengthInputs.defaultProps = {
  submitLengthChange : undefined,
  className: ''
}

export default SearchMenuLengthInputs;
